import * as React from "react";
const AlertCircleBoldSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M10,7.92 L9.4,8.92 L9,8.92 L9.01,4.92 L10,4.92 L10,7.92 Z M10,11.92 L9,11.92 L9.01,10.89 L10,10.89 L10,11.92 Z M9.5,1 C5.36,1 2,4.359 2,8.5 C2,12.65 5.36,16 9.5,16 C13.64,16 17,12.65 17,8.5 C17,4.359 13.64,1 9.5,1 L9.5,1 Z" }));
AlertCircleBoldSmall.displayName = "AlertCircleBoldSmall";
var AlertCircleBoldSmall_default = AlertCircleBoldSmall;
export {
  AlertCircleBoldSmall_default as default
};
